import { FormatMessageType } from '@hooks/useValidation';
import { INTEGER, MIN_FIELD, REQUIRED, REQUIRED_FIELD } from '@utils/validation/validation.constant';
import Yup from '@utils/validation/yup-extended';

export const systemStorageSchema = (formatMessage: FormatMessageType) =>
  Yup.object({
    enabledSensorRawStorage: Yup.boolean(),
    sensorRawStorageDuration: Yup.number()
      .moreThan(
        0,
        formatMessage(
          { id: MIN_FIELD },
          { value: 0, field: formatMessage({ id: 'components.systemParameters.sensorRawStorage' }) },
        ),
      )
      .required(
        formatMessage(
          { id: REQUIRED_FIELD },
          { field: formatMessage({ id: 'components.systemParameters.sensorRawStorage' }) },
        ),
      ),
    enabledSituationStorage: Yup.boolean(),
    situationStorageDuration: Yup.number()
      .moreThan(
        0.1,
        formatMessage(
          { id: MIN_FIELD },
          { value: 0, field: formatMessage({ id: 'components.systemParameters.situationStorage' }) },
        ),
      )
      .required(
        formatMessage(
          { id: REQUIRED_FIELD },
          { field: formatMessage({ id: 'components.systemParameters.situationStorage' }) },
        ),
      ),
    enabledLadVideoStreamStorage: Yup.boolean().required(formatMessage({ id: REQUIRED })),
    ladVideoStreamStorageDuration: Yup.number()
      .moreThan(
        0,
        formatMessage(
          { id: MIN_FIELD },
          { value: 0, field: formatMessage({ id: 'components.systemParameters.ladVideoStreamStorage' }) },
        ),
      )
      .integer(
        formatMessage(
          { id: INTEGER },
          { field: formatMessage({ id: 'components.systemParameters.ladVideoStreamStorage' }) },
        ),
      )
      .required(
        formatMessage(
          { id: REQUIRED_FIELD },
          { field: formatMessage({ id: 'components.systemParameters.ladVideoStreamStorage' }) },
        ),
      ),
  });
